<template>
  <v-dialog v-model="visible" width="600" transition="dialog-transition">
    <v-card class="pa-0">
      <v-card-title class="d-flex align-center" style="gap: 8px;">
        <div class="flex-grow-1 d-flex align-center" style="min-width: 0;">
          <v-text-field
            ref="searchInput"
            v-model="query"
            placeholder="Search Ctrl + K"
            prepend-inner-icon="mdi-magnify"
            solo
            hide-details
            class="white-bg no-shadow w-100"
            @keydown="handleKeyDown"
          >
            <template #append-outer>
              <div class="d-flex align-center" style="height: 100%;">
                <v-btn
                  x-small
                  color="error"
                  class="px-2 py-3 rounded text-caption elevation-0"
                  style="min-width: auto; font-size: 11px;"
                  @click="close"
                  aria-label="Close search"
                >
                  Esc
                </v-btn>
              </div>
            </template>
          </v-text-field>
        </div>
      </v-card-title>

      <v-divider></v-divider>

      <div class="command-scroll-container px-4 mt-2" ref="scrollContainer">
        <v-list dense>
          <div v-for="(group, groupIndex) in filteredGroups" :key="group.title">
            <template v-if="group.items.length > 0">
              <v-subheader class="text-uppercase font-weight-bold grey--text text--darken-1">
                {{ group.title }}
              </v-subheader>

              <v-list-item
                v-for="(item, itemIndex) in group.items"
                :key="item.label"
                :ref="focusedIndex === flatIndex(groupIndex, itemIndex) ? 'focusedItem' : null"
                :class="{ 'v-list-item--focused': focusedIndex === flatIndex(groupIndex, itemIndex) }"
                @click="navigate(item)"
              >
                <v-list-item-icon>
                  <v-icon small class="grey--text text--darken-1">mdi-pound</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-medium">
                    <span v-html="highlightAll(item.label)" />
                  </v-list-item-title>
                  <v-list-item-subtitle
                    v-if="item.description"
                    class="truncate grey--text text--darken-1"
                  >
                    <span v-html="highlightAll(item.description)" />
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </template>
          </div>

          <v-list-item v-if="flatMenu.length === 0">
            <v-list-item-content>
              <v-list-item-title class="grey--text text--darken-1">
                Tidak ada nama menu <span class="blue--text font-weight-bold">"{{ query }}"</span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>

      <div class="command-footer"></div>
    </v-card>
  </v-dialog>
</template>

<script>
import localMenus from './attributes';

export default {
  data() {
    return {
      visible: false,
      query: '',
      focusedIndex: 0,
      localMenus
    };
  },
  computed: {
    accessMenu() {
      return this.$store.state.menus;
    },
    accessibleRoutes() {
      return this.extractRoutes(this.accessMenu);
    },
    menus() {
      const routes = this.accessibleRoutes;
      return this.localMenus.map(group => {
        const flattenedItems = [];
        group.items.forEach(item => {
          if (item.items && Array.isArray(item.items) && !item.label) {
            item.items.forEach(nestedItem => {
              if (nestedItem.items && Array.isArray(nestedItem.items) && !nestedItem.label) {
                flattenedItems.push(...nestedItem.items);
              } else if (nestedItem.label) {
                flattenedItems.push(nestedItem);
              }
            });
          } else if (item.label) {
            flattenedItems.push(item);
          }
        });
        
        const filteredItems = flattenedItems.filter(item =>
          item.route && routes.includes(item.route)
        );
        return {
          title: group.title,
          items: filteredItems
        };
      }).filter(group => group.items.length > 0);
    },
    filteredGroups() {
      const queryNorm = this.normalize(this.query);

      if (!queryNorm) {
        return this.menus;
      }

      const exactItems = [];
      this.menus.forEach(group => {
        group.items.forEach(item => {
          const labelNorm = this.normalize(item.label || '');
          const descNorm = this.normalize(item.description || '');
          const regex = new RegExp(`\\b${queryNorm}\\b`, 'i');
          if (regex.test(labelNorm) || regex.test(descNorm)) {
            exactItems.push({ ...item, groupTitle: group.title });
          }
        });
      });

      if (exactItems.length > 0) {
        return [
          {
            title: 'Hasil Pencarian',
            items: exactItems,
          },
        ];
      }

      const allItems = [];
      this.menus.forEach(group => {
        group.items.forEach(item => {
          const labelScore = this.fuzzyScore(item.label || '', queryNorm);
          const descScore = item.description ? this.fuzzyScore(item.description, queryNorm) : 0;
          const groupScore = this.fuzzyScore(group.title, queryNorm);
          allItems.push({
            ...item,
            score: labelScore + descScore + groupScore,
          });
        });
      });

      const sortedItems = allItems
        .filter(item => item.score > 0)
        .sort((a, b) => b.score - a.score);

      if (sortedItems.length > 0) {
        return [
          {
            title: 'Hasil Pencarian',
            items: sortedItems,
          },
        ];
      }

      return [];
    },

    flatMenu() {
  
      return this.filteredGroups.flatMap(g => g.items);
    }
  },
  watch: {
    query() {
      this.focusedIndex = 0;
    },
    visible(val) {
      if (val) {
        this.$nextTick(() => {
          setTimeout(() => {
            const input = this.$refs.searchInput?.$el?.querySelector('input');
            if (input) input.focus();
          }, 50);
        });
      }
    }
  },
  methods: {
    extractRoutes(accessMenus) {
      const routes = [];
      accessMenus.forEach(group => {
        if (group.link) {
          routes.push(group.link);
        }
        if (group.child && group.child.length > 0) {
          group.child.forEach(child => {
            if (child.link) {
              routes.push(child.link);
            }
            if (child.child && child.child.length > 0) {
              child.child.forEach(grandChild => {
                if (grandChild.link) {
                  routes.push(grandChild.link);
                }
              });
            }
          });
        }
      });
      return routes;
    },
    normalize(str) {
      return str
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();
    },
    fuzzyScore(text, query) {
      const normText = this.normalize(text);
      const queries = this.normalize(query).split(/\s+/);

      let totalScore = 0;

      const matched = queries.every(q => {
        let lastIndex = -1;
        let matchScore = 0;
        const qChars = [...q];

        const allMatched = qChars.every(char => {
          const index = normText.indexOf(char, lastIndex + 1);
          if (index === -1) return false;
          lastIndex = index;
          matchScore += 1;
          return true;
        });
        if (allMatched) {
          totalScore += matchScore;
        }
        return allMatched;
      });

      return matched ? totalScore : 0;
    },
    highlightAll(text) {
      if (!this.query) return text;

      const normalizedText = this.normalize(text);
      const normalizedQuery = this.normalize(this.query.trim());

      const wordRegex = new RegExp(`\\b(${normalizedQuery})\\b`, 'i');
      const match = normalizedText.match(wordRegex);

      if (match) {
        const start = normalizedText.indexOf(match[1]);
        const end = start + match[1].length;

        return (
          `${text.slice(0, start) 
          }<span class="orange--text font-weight-bold">${text.slice(start, end)}</span>${ 
            text.slice(end)}`
        );
      }

      const rawChars = [...text];
      const normChars = [...this.normalize(text)];
      const queryChars = [...normalizedQuery];

      const matchIndices = new Set();
      let textIdx = 0;

      for (let qIdx = 0; qIdx < queryChars.length; qIdx += 1) {
        const qChar = queryChars[qIdx];
        while (textIdx < normChars.length) {
          if (normChars[textIdx] === qChar) {
            matchIndices.add(textIdx);
            textIdx += 1;
            break;
          }
          textIdx += 1;
        }
        if (textIdx >= normChars.length && qIdx < queryChars.length - 1) {
          break;
        }
      }

      let result = '';
      for (let i = 0; i < rawChars.length; i += 1) {
        if (matchIndices.has(i)) {
          result += `<span class="orange--text font-weight-bold">${rawChars[i]}</span>`;
        } else {
          result += rawChars[i];
        }
      }
      return result;
    },

    open() {
      this.visible = true;
      this.query = '';
      this.focusedIndex = 0;

      this.$nextTick(() => {
        setTimeout(() => {
          const container = this.$refs.scrollContainer;
          if (container) {
            container.scrollTop = 0;
          }
        }, 0);
      });
    },
    close() {
      this.visible = false;
      this.focusedIndex = 0;

      this.$nextTick(() => {
        setTimeout(() => {
          const container = this.$refs.scrollContainer;
          if (container) {
            container.scrollTop = 0;
          }
        }, 0);
      });
    },
    navigate(item) {
      if (item.route) {
        this.$router.push(item.route);
        this.close();
      }
    },
    selectFocused() {
      const item = this.flatMenu[this.focusedIndex];
      if (item) this.navigate(item);
    },
    moveFocus(delta) {
      const len = this.flatMenu.length;
      if (len === 0) return;

      this.focusedIndex = (this.focusedIndex + delta + len) % len;

      this.$nextTick(() => {
        const container = this.$refs.scrollContainer;
        const focusedComponent = Array.isArray(this.$refs.focusedItem)
          ? this.$refs.focusedItem[0]
          : this.$refs.focusedItem;
        const focusedEl = focusedComponent?.$el || focusedComponent;

        if (focusedEl && container) {
          const elTop = focusedEl.offsetTop;
          const elBottom = elTop + focusedEl.offsetHeight;
          const containerTop = container.scrollTop;
          const containerBottom = containerTop + container.clientHeight;

          if (elTop < containerTop) {
            container.scrollTop = elTop - 200;
          } else if (elBottom > containerBottom) {
            container.scrollTop = elBottom - container.clientHeight - 50;
          }
        }
      });
    }
    ,


    flatIndex(groupIndex, itemIndex) {
      const before = this.filteredGroups.slice(0, groupIndex).flatMap(g => g.items);
      return before.length + itemIndex;
    },
    handleKeyDown(e) {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        this.moveFocus(1);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        this.moveFocus(-1);
      } else if (e.key === 'Enter') {
        e.preventDefault();
        this.selectFocused();
      }
    },
    handleShortcut(e) {
      if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
        e.preventDefault();
        this.open();
      }
    },
    handleEsc(e) {
      if (this.visible && e.key === 'Escape') {
        e.preventDefault();
        this.close();
      }
    }
  },
  mounted() {
    window.addEventListener('keydown', this.handleShortcut);
    window.addEventListener('keydown', this.handleEsc);
    this.$root.$on('open-command-palette', this.open);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleShortcut);
    window.removeEventListener('keydown', this.handleEsc);
    this.$root.$off('open-command-palette', this.open);
  }
};
</script>

<style scoped>
.command-scroll-container {
  max-height: 400px;
  min-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
}

.v-list-item {
  margin-bottom: 4px;
  padding: 6px 10px;
  transition: background-color 0.2s ease
}

.v-list-item--focused {
  outline: 2px solid #378595 !important;
  outline-offset: -2px;
  border-radius: 6px;
  background-color: #e4f6fa !important;
}

.no-shadow >>> .v-input__slot {
  box-shadow: none !important;
}

.no-shadow >>> input {
  background-color: white !important;
  color: black !important;
  box-shadow: none !important;
}

.no-shadow >>> .v-input__control {
  background-color: white !important;
}

.command-footer {
  height: 40px;
  background-color: white;
}

.truncate {
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
  line-height: 1.2;
  margin-top: 2px;
  font-weight: normal !important;
}
</style>
